import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FeaturesComponent } from './features/features.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { PlantpredictorComponent } from './plantpredictor/plantpredictor.component';
import { GetanswersComponent } from './getanswers/getanswers.component';
import { AskquestionsComponent } from './askquestions/askquestions.component';
import { NgbAccordionModule, NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { UserdashComponent } from './userdash/userdash.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { ProcessHTTPMsgService } from './services/process-httpmsg.service';
import {HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { baseURL, imgbaseURL } from './services/baseurl';
import { AuthInterceptor, UnauthorizedInterceptor } from './services/auth.interceptor';
import { QuestionhomeComponent } from './questionhome/questionhome.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material';
import { ConfirmdialogComponent } from './confirmdialog/confirmdialog.component';
import 'hammerjs';
import { UserupdateComponent } from './userupdate/userupdate.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ConfirmdeleteComponent } from './confirmdelete/confirmdelete.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FeaturesComponent,
    HomeComponent,
    FooterComponent,
    LoginComponent,
    RegisterComponent,
    PlantpredictorComponent,
    GetanswersComponent,
    AskquestionsComponent,
    UserdashComponent,
    QuestionhomeComponent,
    ConfirmdialogComponent,
    UserupdateComponent,
    ResetpasswordComponent,
    ConfirmdeleteComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbAccordionModule,
    NgbTooltipModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDialogModule,
  ],
  providers: [
    AuthService,
    AuthGuardService,
    ProcessHTTPMsgService,
    {provide: 'baseURL', useValue: baseURL},
    {provide: 'imgbaseURL', useValue: imgbaseURL},
    /*{
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true
    }*/
  ],
  entryComponents:[ConfirmdialogComponent, UserupdateComponent, ResetpasswordComponent, ConfirmdeleteComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
